import { Injectable } from '@angular/core';

import { AuthService } from "../../../../shared/services/auth.service";
import { estruturasRoute } from "../../../shared/data.service";
import { newRoute, editRoute } from "../../../../shared/services/data.service";
import { orgaosRoute } from "../../shared/data.service";
import { orgaoTiposRoute } from "./data.service";

@Injectable()
export class OrgaoTipoNavigationService {

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = estruturasRoute + '/' + orgaosRoute + '/' + orgaoTiposRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = estruturasRoute + '/' + orgaosRoute + '/' + orgaoTiposRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = estruturasRoute + '/' + orgaosRoute + '/' + orgaoTiposRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-tipos/shared/orgao-tipo-navigation.service.ts
 **/